import { Typography } from "@mui/material";
import { AnimatePresence, motion, useReducedMotion } from "framer-motion";
import type { FC } from "react";
import { ANNIE_STUDIO, FONT_SIZE, INK, MOTION, NEUTRAL, SHADOW, SURFACE } from "@/theme/tokens";

const BUBBLE_DURATION_S = MOTION.DURATION.ENTRANCE_SM / 1000;

type Props = {
	text: string;
	compact: boolean;
};

/** Annie's reaction line on the stage; the tail corner sits at inline-start, so it points at her in either direction. */
export const AnnieStudioBubble: FC<Props> = ({ text, compact }) => {
	const reduceMotion = useReducedMotion();
	return (
		<AnimatePresence mode="wait" initial={false}>
			<motion.div
				key={text}
				initial={reduceMotion ? { opacity: 0 } : { opacity: 0, transform: `translateY(${ANNIE_STUDIO.BUBBLE_RISE_PX}px)` }}
				animate={reduceMotion ? { opacity: 1 } : { opacity: 1, transform: "translateY(0px)" }}
				exit={{ opacity: 0 }}
				transition={{ duration: BUBBLE_DURATION_S, ease: MOTION.EASE_OUT_POINTS }}
			>
				<Typography
					data-testid="annie-studio-bubble"
					sx={{
						px: 1.5,
						py: 0.75,
						bgcolor: SURFACE,
						border: `1px solid ${NEUTRAL[200]}`,
						borderRadius: `${ANNIE_STUDIO.BUBBLE_RADIUS_PX}px`,
						borderEndStartRadius: `${ANNIE_STUDIO.BUBBLE_TAIL_RADIUS_PX}px`,
						boxShadow: SHADOW.PANEL_SOFT_HOVER,
						fontWeight: 700,
						fontSize: compact ? FONT_SIZE.SECONDARY : FONT_SIZE.EMPHASIS,
						color: INK.PRIMARY,
						textAlign: "center",
					}}
				>
					{text}
				</Typography>
			</motion.div>
		</AnimatePresence>
	);
};
